import React, { useState } from 'react';
import { createModel } from '../utils/api';

const NewModel = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    legalName: '',
    yearOfBirth: '',
    monthOfBirth: '',
    dayOfBirth: '',
    ethnicity: '',
    sex: '',
    kids: false,
    projectNr: '',
    castingFor: '',
    castingDate: '',
    castingLocation: '',
    nationality: '',
    countryBasedIn: '',
    cityBasedIn: '',
    height: '',
    bust: '',
    chest: '',
    cup: '',
    waist: '',
    hips: '',
    size: '',
    shoeSize: '',
    waistJeans: '',
    inseamJeans: '',
    eyes: '',
    hair: '',
    primaryImages: [{ url: '' }],
    videos: [{ url: '' }],

  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleArrayChange = (e, field, index, key) => {
    const { value } = e.target;
    const updatedArray = [...formData[field]];
    updatedArray[index][key] = value;
    setFormData({ ...formData, [field]: updatedArray });
  };
  const sanitizeFormData = (data) => {
    const sanitizedData = {};
    for (const key in data) {
      sanitizedData[key] = data[key] === '' ? null : data[key]; // Convert empty strings to null
    }
    return sanitizedData;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
  
    try {
      // Wrap formData inside a "model" object, if required by the API
      const sanitizedData = sanitizeFormData(formData);
      const payload = { model: sanitizedData };
      console.log('Submitting:', JSON.stringify(payload, null, 2));
  
      const response = await createModel(payload); // Adjusted payload structure
      console.log('Model created successfully:', response.data);
      alert('Model created successfully!');
  
      setFormData({
        firstName: '',
        lastName: '',
        legalName: '',
        yearOfBirth: '',
        monthOfBirth: '',
        dayOfBirth: '',
        ethnicity: '',
        sex: '',
        kids: false,
        projectNr: '',
        castingFor: '',
        castingDate: '',
        castingLocation: '',
        nationality: '',
        countryBasedIn: '',
        cityBasedIn: '',
        height: '',
        bust: '',
        chest: '',
        cup: '',
        waist: '',
        hips: '',
        size: '',
        shoeSize: '',
        waistJeans: '',
        inseamJeans: '',
        eyes: '',
        hair: '',
        primaryImages: [{ url: '' }],
        videos: [{ url: '' }],
      });
    } catch (err) {
      console.error('Error creating model:', err);
  
      if (err.response) {
        console.error('Error Response Data:', err.response.data);
        alert(`Error: ${err.response.data.message || 'Failed to create model.'}`);
      } else {
        console.error('Request Error:', err.message);
        alert(`Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className='container'>
        <div className='model-all'><form onSubmit={handleSubmit} className="new-model-form">
      <h1 className="title">Add a New Model</h1>

      {/* Personal Information */}
      <div className="form-row">
        <input className="inputtext" name="firstName" type="text" value={formData.firstName} onChange={handleChange} required placeholder="First Name" />
        <input className="inputtext" name="lastName" type="text" value={formData.lastName} onChange={handleChange} required placeholder="Last Name" />
        <input className="inputtext" name="legalName" type="text" value={formData.legalName} onChange={handleChange} placeholder="Legal Name" />
      </div>

      <div className="form-row">
        <input className="inputtext" name="yearOfBirth" type="number" value={formData.yearOfBirth} onChange={handleChange} placeholder="Year of Birth" />
        <input className="inputtext" name="monthOfBirth" type="number" value={formData.monthOfBirth} onChange={handleChange} placeholder="Month of Birth" />
        <input className="inputtext" name="dayOfBirth" type="number" value={formData.dayOfBirth} onChange={handleChange} placeholder="Day of Birth" />
      </div>

      <div className="form-row">
        <input className="inputtext" name="ethnicity" type="text" value={formData.ethnicity} onChange={handleChange} placeholder="Ethnicity" />
        <input className="inputtext" name="sex" type="text" value={formData.sex} onChange={handleChange} placeholder="Sex" />
      </div>
      <div className="form-row">
        <input
          className="inputtext"
          name="nationality"
          type="text"
          value={formData.nationality}
          onChange={handleChange}
          placeholder="Nationality"
        />
        <input
          className="inputtext"
          name="countryBasedIn"
          type="text"
          value={formData.countryBasedIn}
          onChange={handleChange}
          placeholder="Country Based In"
        />
        <input
          className="inputtext"
          name="cityBasedIn"
          type="text"
          value={formData.cityBasedIn}
          onChange={handleChange}
          placeholder="City Based In"
        />
      </div>


      {/* Measurements */}
      <div className="form-row">
        <input className="inputtext" name="height" type="number" value={formData.height} onChange={handleChange} placeholder="Height (cm)" />
        <input className="inputtext" name="bust" type="number" value={formData.bust} onChange={handleChange} placeholder="Bust" />
        <input className="inputtext" name="chest" type="number" value={formData.chest} onChange={handleChange} placeholder="Chest" />
      </div>

      <div className="form-row">
        <input className="inputtext" name="waist" type="number" value={formData.waist} onChange={handleChange} placeholder="Waist" />
        <input className="inputtext" name="hips" type="number" value={formData.hips} onChange={handleChange} placeholder="Hips" />
        <input className="inputtext" name="shoeSize" type="number" value={formData.shoeSize} onChange={handleChange} placeholder="Shoe Size" />
      </div>

      {/* Files and Images */}
      <div className="form-row">
        <input className="inputtext" name="primaryImages[0].url" type="text" value={formData.primaryImages[0].url} onChange={(e) => handleArrayChange(e, 'primaryImages', 0, 'url')} placeholder="Primary Image URL" />
        <input className="inputtext" name="videos[0].url" type="text" value={formData.videos[0].url} onChange={(e) => handleArrayChange(e, 'videos', 0, 'url')} placeholder="Video URL" />
      </div>

      {/* Boolean Fields */}
      <div className="form-row">
        <label>
          <input type="checkbox" name="kids" checked={formData.kids} onChange={handleChange} /> Kids
        </label>
        <label>
          <input type="checkbox" name="newFace" checked={formData.newFace} onChange={handleChange} /> New Face
        </label>
      </div>
 {error && <p className="error">{error}</p>}
      <button className="big-button" type="submit" disabled={loading}>
        {loading ? 'Creating...' : 'Create Model'}
      </button>
    </form>
    </div>
    </div>
  );
};

export default NewModel;
